module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ico_gradient/gift-ico-gradient-81968a4c2f508b2936f6d81688ac5ca0.svg";